<template>
	<div class="biz_contentsMenu">
		<div class="contentMenuArea">
			<div v-if="!isSmartPhone">
				<div class="contentMenu" v-for="(menu, index) in menus" v-bind:class="{'active': isActive[index]}" @mouseover="moveUnderBar(index + 1)"><div style="cursor:pointer" @click="scrollAnswer(menu.anker)">{{menu.name}}</div></div>
				<div class="menuUnderbar"></div>
			</div>
			<div v-if="isSmartPhone">
				<div>
					<div class="tblcell contentMenu" v-bind:class="{'active': isActive[0]}" @mouseover="moveUnderBar(1)"><div style="cursor:pointer" @click="scrollAnswer(menus[0].anker)">{{menus[0].name}}</div></div>
					<div class="tblcell contentMenu" v-bind:class="{'active': isActive[1]}" @mouseover="moveUnderBar(2)"><div style="cursor:pointer" @click="scrollAnswer(menus[1].anker)">{{menus[1].name}}</div></div>
					<div class="tblcell contentMenu" v-bind:class="{'active': isActive[2]}" @mouseover="moveUnderBar(3)"><div style="cursor:pointer" @click="scrollAnswer(menus[2].anker)">{{menus[2].name}}</div></div>
				</div>
				<div>
					<div class="tblcell contentMenu" v-bind:class="{'active': isActive[3]}" @mouseover="moveUnderBar(4)"><div style="cursor:pointer" @click="scrollAnswer(menus[3].anker)">{{menus[3].name}}</div></div>
					<div class="tblcell contentMenu" v-bind:class="{'active': isActive[4]}" @mouseover="moveUnderBar(5)"><div style="cursor:pointer" @click="scrollAnswer(menus[4].anker)">{{menus[4].name}}</div></div>
					<div class="tblcell contentMenu" v-bind:class="{'active': isActive[5]}" @mouseover="moveUnderBar(6)"><div style="cursor:pointer" @click="scrollAnswer(menus[5].anker)">{{menus[5].name}}</div></div>
				</div>
				<div class="menuUnderbar"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props:["activeNode"],
	data: function(){
		return {
			isSmartPhone: false,
			isActive: [false, false, false, false, false, false],
			menus:[
				{"name":"ニーズ", "anker":"needs"},
				{"name":"アングル", "anker":"angle"},
				{"name":"RPAシステム", "anker":"rpa"},
				// {"name":"ローコード", "anker":"lowcode"},
				// {"name":"AI議事録", "anker":"aiminutes"},
				{"name":"AI-OCR", "anker":"aiocr"}
			]
		}
	},
	methods: {
		handleResize: function(e) {
			if (window.matchMedia('(max-width:480px)').matches) {
				// SPの処理
				this.isSmartPhone = true;
			} else if (window.matchMedia('(max-width:800px)').matches) {
				// TABの処理
				this.isSmartPhone = false;
			} else {
				// PCの処理
				this.isSmartPhone = false;
			}
		},

		moveUnderBar: function(num){
			var area = document.getElementsByClassName('contentMenuArea')[0];
			var ac = "";
			
			for (var i=0; i<this.menus.length; i++) {
				if (num == (i + 1)) {
					ac = "active"+num;
				} else {
					area.classList.remove("active"+(i + 1));
				}
			}
			area.classList.add(ac);
		},
		
		scrollAnswer: function(name) {
			var element;
			if ('scrollingElement' in document) {
				element = document.scrollingElement;
			} else if (navigator.userAgent.toLowerCase().match(/webkit|msie 5/)) {
				element = document.body;
			} else {
				element = document.documentElement;
			}
			var anc = document.getElementsByName(name)[0];
			var rect = anc.getBoundingClientRect();
			var top = rect.top + element.scrollTop;
			this.scrollTo(top, 300);
		},
		
		scrollTo: function(to, duration) {
			var element;
			if ('scrollingElement' in document) {
				element = document.scrollingElement;
			} else if (navigator.userAgent.toLowerCase().match(/webkit|msie 5/)) {
				element = document.body;
			} else {
				element = document.documentElement;
			}
			if (duration <= 0) return;
			var difference = to - element.scrollTop;
			var perTick = difference / duration * 10;
			var _self = this;
			
			setTimeout(function () {
				element.scrollTop = element.scrollTop + perTick;
				if (element.scrollTop === to) return;
				_self.scrollTo(to, duration - 10); // 再帰で実行
			}, 10);
		}
	},
	created: function(){
		this.handleResize();
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', (e) => {
			this.handleResize(e);
		});
	},
	mounted: function(){
		var area = document.getElementsByClassName('contentMenuArea')[0];
		var bar = document.getElementsByClassName('menuUnderbar')[0];
		this.isActive = [];
		var acn = this.activeNode;
		if (acn == undefined) {
			acn = 1;
		}
		for (var i=0; i<this.menus.length; i++) {
			if ((i + 1) == acn) {
				this.isActive.push(true);
				area.classList.add("active"+acn);
				bar.classList.add("menuUnderbar"+acn);
			} else {
				this.isActive.push(false);
			}
		}
	}
}
</script>

<style lang="less" scoped>
@import "./less/const.less";
.biz_contentsMenu {
	position: relative;
	bottom: 0;
	width: 100%;
	background-color: @bgcolor-white;
	
	.contentMenuArea {
		position: relative;
		margin-left: auto;
		margin-right: auto;
		width: 950px;
		height: 37px;
		
		.contentMenu {
			float: left;
			//width: 33.333%;
			width: 16.666%;
			text-align: center;
			padding: 12px 0;
			font-size: @font-lagesize;
		}
		
		.menuUnderbar {
			position: relative;
			bottom: -34px;
			width: 158.333px;
			height: 3px;
			background-color: @main-red;
		}
		
		.menuUnderbar1 {
			left: 0px;
			transtion: 0.7s left ease;
			-webkit-transition: 0.7s left ease;
		}
		
		.menuUnderbar2 {
			left: 158.333px;
			transtion: 0.7s left ease;
			-webkit-transition: 0.7s left ease;
		}
		
		.menuUnderbar3 {
			left: 316.666px;
			transtion: 0.7s left ease;
			-webkit-transition: 0.7s left ease;
		}
	}
	
	.active1 {
		&:hover {
			.menuUnderbar {
				left: 0;
			}
		}
	}
	
	.active2 {
		&:hover {
			.menuUnderbar {
				left: 158.333px;
			}
		}
	}
	
	.active3 {
		&:hover {
			.menuUnderbar {
				left: 316.666px;
			}
		}
	}

	.active4 {
		&:hover {
			.menuUnderbar {
				left: 474.999px;
			}
		}
	}

	.active5 {
		&:hover {
			.menuUnderbar {
				left: 633.333px;
			}
		}
	}

	.active6 {
		&:hover {
			.menuUnderbar {
				left: 791.665px;
			}
		}
	}
}

/* スマホ横、タブレット縦 */
@media screen and (max-width: 800px) {
	.biz_contentsMenu {
		.contentMenuArea {
			width: 650px;
			
			.menuUnderbar {
				width: 108.333px;
			}
			
			.menuUnderbar2 {
				left: 108.333px;
				transtion: 0.7s left ease;
				-webkit-transition: 0.7s left ease;
			}
			
			.menuUnderbar3 {
				left: 216.666px;
				transtion: 0.7s left ease;
				-webkit-transition: 0.7s left ease;
			}
		}
		
		.active1 {
			&:hover {
				.menuUnderbar {
					left: 0;
				}
			}
		}
		
		.active2 {
			&:hover {
				.menuUnderbar {
					left: 108.333px;
				}
			}
		}
		
		.active3 {
			&:hover {
				.menuUnderbar {
					left: 216.666px;
				}
			}
		}

		.active4 {
			&:hover {
				.menuUnderbar {
					left: 324.999px;
				}
			}
		}

		.active5 {
			&:hover {
				.menuUnderbar {
					left: 433.332px;
				}
			}
		}

		.active6 {
			&:hover {
				.menuUnderbar {
					left: 541.665px;
				}
			}
		}
	}
}
/* スマホ縦 */
@media screen and (max-width: 480px) {
	.biz_contentsMenu {
		.contentMenuArea {
			width: 300px;

			.contentMenu {
				width: 33.333%;
				padding: 5px 0;
			}
			
			.menuUnderbar {
				width: 100px;
				bottom: -28px;
			}
			
			.menuUnderbar2 {
				left: 100px;
				transtion: 0.7s left ease;
				-webkit-transition: 0.7s left ease;
			}
			
			.menuUnderbar3 {
				left: 200px;
				transtion: 0.7s left ease;
				-webkit-transition: 0.7s left ease;
			}
		}
		
		.active1 {
			&:hover {
				.menuUnderbar {
					left: 0;
				}
			}
		}
		
		.active2 {
			&:hover {
				.menuUnderbar {
					left: 100px;
				}
			}
		}
		
		.active3 {
			&:hover {
				.menuUnderbar {
					left: 200px;
				}
			}
		}

		.active4 {
			&:hover {
				.menuUnderbar {
					top: 55px;
					left: 0px;
				}
			}
		}

		.active5 {
			&:hover {
				.menuUnderbar {
					top: 55px;
					left: 100px;
				}
			}
		}

		.active6 {
			&:hover {
				.menuUnderbar {
					top: 55px;
					left: 200px;
				}
			}
		}
	}
}
</style>
